import { render } from "./PresentItem.vue?vue&type=template&id=1c0d3b1b"
import script from "./PresentItem.vue?vue&type=script&lang=js"
export * from "./PresentItem.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__